export default __webpack_public_path__ + "static/media/logo-light.9aed763b.png";